export default {
    STATS(state, data) {
      state.stats = data;
    },
    SALES(state, data) {
      state.sales = data;
    },
    ACTIVITY(state, data) {
      state.activity = data;
    },
    COINS(state, data) {
      state.coins = data;
    },
  }
  